// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__nlR5g","menu":"styles_menu__kofIT","box":"styles_box__bQYDc","activeText":"styles_activeText__rYPGp","header":"styles_header__68rfa"};